<template>
  <div class="pdf-return">
    <div class="pdf-return__card">
      <div class="pdf-return__mark" :class="status">
        <span v-if="status === 'success'">&#10003;</span>
        <span v-else-if="status === 'fail'">&#215;</span>
        <span v-else>&hellip;</span>
      </div>
      <div class="pdf-return__title">{{ statusText }}</div>
      <div class="pdf-return__desc">{{ statusDesc }}</div>
      <div v-if="orderNum" class="pdf-return__order">订单号：{{ orderNum }}</div>
      <a class="pdf-return__btn" :href="appUrl">返回 App</a>
      <div class="pdf-return__tip">正在返回 App，如未自动打开请点击上方按钮</div>
    </div>
  </div>
</template>

<script>
// 固定写死，不支持 App 端自定义传参
const APP_SCHEME = 'wxdhwapp://';

const STATUS_TEXT = {
  success: '支付成功',
  fail: '支付失败',
  pending: '支付处理中'
};
const STATUS_DESC = {
  success: '支付结果已提交，请返回 App 查看到账状态。',
  fail: '支付未完成，请返回 App 后重新发起支付。',
  pending: '支付结果确认中，请返回 App 稍后查看。'
};

export default {
  name: 'PaydifyReturn',
  data() {
    return {
      redirectTimer: null
    };
  },
  computed: {
    orderNum() {
      return String(this.$route.query.orderNum || '');
    },
    status() {
      const raw = String(this.$route.query.status || '').toLowerCase();
      return ['success', 'fail', 'pending'].indexOf(raw) !== -1 ? raw : 'pending';
    },
    statusText() {
      return STATUS_TEXT[this.status];
    },
    statusDesc() {
      return STATUS_DESC[this.status];
    },
    appUrl() {
      const query = {
        orderNum: this.orderNum,
        status: this.status,
        payWay: 'paydify'
      };
      const qs = Object.keys(query)
        .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(query[k]))
        .join('&');
      return APP_SCHEME + 'paydify/return?' + qs;
    }
  },
  mounted() {
    this.redirectTimer = setTimeout(() => {
      window.location.href = this.appUrl;
    }, 500);
  },
  beforeDestroy() {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
      this.redirectTimer = null;
    }
  }
};
</script>

<style scoped>
.pdf-return {
  min-height: 100vh;
  background: #f5f6f8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.2rem;
}
.pdf-return__card {
  width: 100%;
  max-width: 18rem;
  background: #fff;
  border-radius: 0.9rem;
  box-shadow: 0 0.4rem 1.4rem rgba(0, 0, 0, 0.06);
  padding: 2.2rem 1.4rem 2rem;
  text-align: center;
}
.pdf-return__mark {
  width: 3.6rem;
  height: 3.6rem;
  margin: 0 auto 1.1rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: 700;
  color: #fff;
}
.pdf-return__mark.success { background: linear-gradient(135deg, #34d399, #16a34a); }
.pdf-return__mark.fail { background: linear-gradient(135deg, #ff7a59, #f73727); }
.pdf-return__mark.pending { background: linear-gradient(135deg, #fbbf24, #f59e0b); }
.pdf-return__title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #1f2329;
  margin-bottom: 0.55rem;
}
.pdf-return__desc {
  font-size: 0.82rem;
  color: #6b7280;
  line-height: 1.7;
}
.pdf-return__order {
  margin-top: 0.7rem;
  font-size: 0.7rem;
  color: #9099a6;
  word-break: break-all;
}
.pdf-return__btn {
  display: block;
  margin-top: 1.4rem;
  height: 2.6rem;
  line-height: 2.6rem;
  border-radius: 0.5rem;
  background: linear-gradient(to right, #ff704d, #f73727);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
}
.pdf-return__tip {
  margin-top: 0.8rem;
  font-size: 0.68rem;
  color: #b3b8c2;
}
</style>
